module.exports = __webpack_public_path__ + "static/img/vue-logo.48ffbe66.svg";